import { render, staticRenderFns } from "./detail-ddw.vue?vue&type=template&id=6b4b4bb7&scoped=true&"
import script from "./detail-ddw.vue?vue&type=script&lang=js&"
export * from "./detail-ddw.vue?vue&type=script&lang=js&"
import style0 from "./detail-ddw.vue?vue&type=style&index=0&id=6b4b4bb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b4bb7",
  null
  
)

export default component.exports